/**
 * * Модель для описания прикрепленного файла
 */
export class TaskAttachedFileModel {
  /**Идентификатор файла */
  Id!: number;
  /**Имя файла */
  FileName!: string;
  /**Расширение файла */
  FileExtension!: string;

  constructor(obj?: Partial<TaskAttachedFileModel>) {
    Object.assign(this, obj);
  }
}
